import AuthMiddleware from "@/middleware/auth"

const ResendToRxnt = () =>
  import(
    /* webpackChunkName: "resend-to-rxnt" */ "@/views/ResendToRxnt"
  )

const ResendToRxntRouter = [
  {
    path: "/resend-to-rxnt",
    name: "ResendToRxnt",
    component: ResendToRxnt,
    beforeEnter: AuthMiddleware.user,
    meta: {
      title: "UPLOAD MILEAGE CASES",
    },
  },
]

export { ResendToRxntRouter }
